import { Ancestor, Editor } from 'slate';
import { getQueryOptions, WithQueryOptions } from '../utils/match';

export function getAbove<T extends Ancestor>(editor: Editor, options?: WithQueryOptions<typeof Editor.above, 1>) {
    return Editor.above<T>(editor, getQueryOptions(editor, options));
}
